<template>
  <span>{{ displayName }}</span>
</template>

<script setup lang="ts">
import { computed } from "vue";

import CommonModule from "@/store/modules/common";

type Props = {
  row: Record<string, unknown>;
};

const props = defineProps<Props>();

/**
 * Localized country name resolved from `CommonModule.countries` (populated at
 * Login via `fetchCountries`). Falls back to the raw 2-letter code when the
 * countries store is empty or doesn't contain a match.
 *
 * @returns {string}
 */
const displayName = computed((): string => {
  const code = String(props.row.country || "");

  if (!code) {
    return "";
  }

  const country = CommonModule.countries.find((c) => c.code === code);

  return country?.name || code;
});
</script>
